import React from "react";
import Dropbox from "../../../../../../components/svgs/Dropbox";
import SharePoint from "../../../../../../components/svgs/SharePoint";
import GoogleDrive from "../../../../../../components/svgs/GoogleDrive";
import { hasAllDataRepoPermission } from "../../../../../../utils";

export default function DataRoomButtons({
    company,
    user,
    tab,
    syncing,
    syncApiBase,
    onConnectDataRoom,
    syncDrive,
    syncDropbox,
    reverseSyncDropbox,
    syncSharePoint,
    reSyncSharePoint,
    handleDisconnectDataRoom,
    localModule,
    isDataRepository,
    isTwoMinuteTesHomePage,
}) {
    if (isTwoMinuteTesHomePage) {
        return (
            <div className="df aic mt0-5rem">
                <button disabled data-tooltip="Connect Data room feature is disabled. You must register to access it." className="op50 cp bg1 c3 bw1px bo3 bss br50px fs0-75rem fw600 px0-75rem py0-5rem df jcc aic mr0-5rem">
                    Connect
                    <span className="df ml0-5rem">
                        <GoogleDrive className="pen fds w1rem ml0-5rem" />
                        <Dropbox className="pen fds w1rem ml0-5rem" />
                        <SharePoint className="pen fds w1rem ml0-5rem" />
                    </span>
                </button>
            </div>
        );
    }

    if (!localModule || !isDataRepository || !tab?.includes('repository')) return null;

    const syncLink = company.gDriveLink || company.sharePointLink || company.dropBoxLink;
    const allFiles = [];
    for (const sec of localModule?.sections ?? []) {
        for (const ques of sec?.questions ?? []) {
            const files = ques?.answer?.files ?? [];
            if (files.length > 0) allFiles.push(...files);
        }
    }

    let syncRequired = false;
    if (company.dropBoxFolderMetadata) syncRequired = allFiles.some((f) => !f?.dbFileMetadata);
    if (company.sharePointLink) syncRequired = allFiles.some((f) => !f?.spDriveItem);
    const disableSyncButton = !syncRequired;

    const isMember = company['members']?.some(m => m._id === user._id) || company?.['advisors']?.[user._id];
    const hasAllPermissions = company ? hasAllDataRepoPermission(company?.['memberPermissions']?.[user._id]) || hasAllDataRepoPermission(company?.['advisors']?.[user._id]?.['modules']) : false;
    const isInvestorOwner = company?.['investors'] && Object.keys(company['investors']).length > 0 && company['investors'][user._id] && hasAllDataRepoPermission(company?.['investors']?.[user._id]?.['modules']);
    const canManageDataRoom = ((!company?.isParent && company?.owners?.[0] === user._id) || (company?.isParent && company?.owners?.[0] === user._id) || ((company?.servicedBy?._id || company?.servicedBy) === user._id) || (isMember && hasAllPermissions) || isInvestorOwner);

    if (!canManageDataRoom) return null;

    const openWindow = (url) => window.open(url, "_blank");

    return (
        <div className="df aic mt0-5rem">
            {/* Connect button (not connected) */}
            {syncLink == undefined && (
                <button onClick={() => onConnectDataRoom(syncApiBase)} className={` cp fs13px fw600 bg1 c3 bw1px bo3 bss br50px px1rem py0-5rem mr0-5rem df jcc aic`}>
                    Connect
                    <span className="df ml0-5rem">
                        <GoogleDrive className="pen fds w1rem ml0-5rem" />
                        <Dropbox className="pen fds w1rem ml0-5rem" />
                        <SharePoint className="pen fds w1rem ml0-5rem" />
                    </span>
                </button>
            )}
            {/* Data Room dropdown (connected) */}
            {syncLink !== undefined && (
                <div className="pr menuHover mr0-5rem">
                    <button className="cp fs13px fw600 bg1 c3 bw1px bo3 bss br50px px1rem py0-5rem df jcc aic">
                        {company.gDriveLink && <GoogleDrive className="pen fds w1rem mr0-5rem" />}
                        {company.dropBoxLink && <Dropbox className="pen fds w1rem mr0-5rem" />}
                        {company.sharePointLink && <SharePoint className="pen fds w1rem mr0-5rem" />}
                        Data Room
                        <span className="ml0-5rem c3">&#9662;</span>
                    </button>
                    <div className="menu op0 pen zi10 bg1 br10px shadow pa l0 df fdc" style={{ minWidth: '230px' }}>
                        {/* Google Drive */}
                        {company.gDriveLink && <>
                            {company.folderId && (
                                <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`} style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                                    <button disabled={syncing} onClick={() => openWindow(`https://drive.google.com/drive/folders/${company.folderId}`)} className={`cp df aic ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                        <span className="df"><GoogleDrive className="pen fds w1rem mr0-5rem" /></span>View Data Room
                                    </button>
                                </p>
                            )}
                            <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`}>
                                <button disabled={syncing} onClick={() => syncDrive()} className={`cp df aic ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                    <img className="mr0-5rem" src={require('../../../../../../../images/sync-data-room.png')} alt="sync-data-room" />Sync Data Room
                                </button>
                            </p>
                            <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`} style={{ borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                                <button disabled={syncing} onClick={() => handleDisconnectDataRoom("gdrive")} className={`cp df aic ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                    <i className="fa fa-unlink c4 mr0-5rem" />Disconnect
                                </button>
                            </p>
                        </>}
                        {/* Dropbox */}
                        {company.dropBoxLink && <>
                            {company.dropBoxFolderMetadata && (
                                <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`} style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                                    <button disabled={syncing} onClick={() => openWindow(`https://dropbox.com/home/${company.dropBoxFolderMetadata.path_display}`)} className={`cp df aic ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                        <span className="df"><Dropbox className="pen fds w1rem mr0-5rem" /></span>View Data Room
                                    </button>
                                </p>
                            )}
                            <p className={`${(company.syncRequired || syncRequired) ? 'op100' : 'op60'} cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || disableSyncButton) && 'op60 cnd'}`}>
                                <button disabled={syncing || disableSyncButton} onClick={() => syncDropbox()} className={`${(company.syncRequired || syncRequired) ? 'op100' : 'op60'} cp df aic ${(syncing || disableSyncButton) && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                    <img className="mr0-5rem" src={require('../../../../../../../images/sync-data-room.png')} alt="sync-data-room" />Sync Data Room
                                </button>
                            </p>
                            <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || company.syncRequired || syncRequired) && 'op60 cnd'}`}>
                                <button onClick={() => reverseSyncDropbox()} className="cp df aic" style={{ background: 'transparent' }}>
                                    <img className="mr0-5rem" src={require('../../../../../../../images/sync-data-room.png')} alt="sync-data-room" />Reverse Sync
                                </button>
                            </p>
                            <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`} style={{ borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                                <button disabled={syncing} onClick={() => handleDisconnectDataRoom("dropbox")} className={`cp df aic ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                    <i className="fa fa-unlink c4 mr0-5rem" />Disconnect
                                </button>
                            </p>
                        </>}
                        {/* SharePoint */}
                        {company.sharePointLink && <>
                            {company.sharePointFolderDriveItem?.rootFolder?.webUrl && (
                                <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`} style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                                    <button disabled={syncing} onClick={() => openWindow(`${company.sharePointFolderDriveItem.rootFolder.webUrl}`)} className={`cp df aic ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                        <span className="df"><SharePoint className="pen fds w1rem mr0-5rem" /></span>View Data Room
                                    </button>
                                </p>
                            )}
                            <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || disableSyncButton) && 'op60 cnd'}`}>
                                <button disabled={syncing || disableSyncButton} onClick={() => syncSharePoint()} className={`cp df aic ${(syncing || disableSyncButton) && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                    <img className="mr0-5rem" src={require('../../../../../../../images/sync-data-room.png')} alt="sync-data-room" />Sync Data Room
                                </button>
                            </p>
                            <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || company.syncRequired || syncRequired) && 'op60 cnd'}`}>
                                <button disabled={syncing || company.syncRequired || syncRequired} onClick={() => reSyncSharePoint()} className={`cp df aic ${(syncing || company.syncRequired || syncRequired) && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                    <img className="mr0-5rem" src={require('../../../../../../../images/sync-data-room.png')} alt="sync-data-room" />Reverse Sync
                                </button>
                            </p>
                            <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`} style={{ borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                                <button disabled={syncing} onClick={() => handleDisconnectDataRoom("sharepoint")} className={`cp df aic ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                    <i className="fa fa-unlink c4 mr0-5rem" />Disconnect
                                </button>
                            </p>
                        </>}
                    </div>
                </div>
            )}
            {/* Analyse All */}
            {/* <button className="cp fs13px fw600 bg1 c3 bw1px bo3 bss br50px px1rem py0-5rem df jcc aic">
                <img src={require("../../../../../../../images/double-star-icon.png")} alt="double-star-icon" className="w20px h20px mr0-5rem" />
                Analyse All
            </button> */}
        </div>
    );
}
